<template>
    <form class="unlayer-landing-page">
        <div class="unlayer-landing-page-body">
            <p class="summary-text">
                {{ MESSAGE_CONSTANTS.message }}
            </p>
            <table class="table-lp">
                <tr>
                    <td class="left-column">
                        <ds-multiselect
                            id="unlayerLandingPage-selection"
                            :key="unlayerPageKeyId"
                            v-model="selectedUnlayerLandingPage"
                            :placeholder="MESSAGE_CONSTANTS.selectLandingPage_placeholder"
                            searchable
                            label-prop="title"
                            value-prop="id"
                            :loading="loadingLandingPage"
                            :options="unlayerLandingPageOptions"
                            @input="loadUnlayerForm"
                            @updateSearch="searchLandingPage"
                        />
                    </td>
                    <td class="right-column">
                        <ds-filled-button
                            class="edition"
                            :disabled="isLadingPageSelected"
                            @click="editLandingPage"
                        >
                            {{ MESSAGE_CONSTANTS.editLandingPage }}
                        </ds-filled-button>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="single-column">
                        <ds-multiselect
                            id="unlayerForm-selection"
                            :key="unlayerFormKeyId"
                            v-model="selectedUnlayerForm"
                            multiple
                            searchable
                            bind-value-only
                            :placeholder="MESSAGE_CONSTANTS.selectForm_placeholder"
                            :loading="loadingLandingPage || loadingForms"
                            :options="unlayerFormOptions"
                        />
                    </td>
                </tr>
            </table>
            <table class="table-lp">
                <tr>
                    <td class="single-column">
                        <a
                            :title="landingPageLink"
                            :href="landingPageLink"
                            class="create-landing-page-link"
                            target="_blank"
                        >
                            {{ MESSAGE_CONSTANTS.createLandingPage }}
                            <ds-icon name="external-link" />
                        </a>
                    </td>
                </tr>
            </table>
        </div>
        <ds-icon-button
            :aria-label="MESSAGE_CONSTANTS.close"
            class="close-modal"
            @click="closeModal"
        >
            <ds-icon name="x" />
        </ds-icon-button>
        <ds-filled-button
            class="save-button"
            :disabled="isSaveDisabled"
            @click="saveCell"
        >
            {{ MESSAGE_CONSTANTS.save }}
        </ds-filled-button>
    </form>
</template>
<script>
import { dataService } from './shared/data.service';
import debounce from 'lodash.debounce';


export default {

    props: {
        vueComponentId: String,
        inputDelay: {
            type: Number,
            default: 500,
        },
        spaBaseUrl: String,
        appId: String,
        createUrl: String,
        editUrl: String,
        spaApp: Boolean,
        newNavigation: Boolean,
    },
    data() {
        return {
            jgraph: {},
            cellInfo: {},
            cellValue: {},
            saveCellOptions: {},
            selectedUnlayerLandingPage: null,
            selectedUnlayerForm: [],
            unlayerPageKeyId: 'unlayerPageKeyMS-0',
            unlayerFormKeyId: 'unlayerFormKeyMS-0',
            unlayerLandingPageOptions: [],
            unlayerFormOptions: [],
            loadingLandingPage: false,
            loadingForms: false,
            MESSAGE_CONSTANTS: {
                message: '',
                selectLandingPage_placeholder: '',
                selectForm_placeholder: '',
                createLandingPage: '',
                save: '',
                close: '',
                editLandingPage: '',
            },
        };
    },

    created () {
        this.MESSAGE_CONSTANTS.message = window.keapI18nMap['campaign.landing.page.message'];
        this.MESSAGE_CONSTANTS.selectLandingPage_placeholder = window.keapI18nMap['campaign.landing.page.selectLandingPage.placeholder'];
        this.MESSAGE_CONSTANTS.selectForm_placeholder = window.keapI18nMap['funnel.edit.goal.smartForm.defaultOption'];
        this.MESSAGE_CONSTANTS.createLandingPage = window.keapI18nMap['campaign.landing.page.createLandingPage'];
        this.MESSAGE_CONSTANTS.save = window.keapI18nMap['campaign.landing.page.save'];
        this.MESSAGE_CONSTANTS.editLandingPage = window.keapI18nMap['campaign.landing.page.edit'];
        this.MESSAGE_CONSTANTS.close = window.keapI18nMap['campaign.landing.page.configure.close'];
    },
    async mounted () {
        document.getElementById(this.vueComponentId).addEventListener('loadCellValueObject', this.loadCellValueObject);
        await this.loadUnlayerLandingPageOptions();

        if (this.inputDelay) {
            this.searchLandingPage = debounce(this.searchLandingPage, this.inputDelay);
        }
    },
    beforeDestroy () {
        document.getElementById(this.vueComponentId).removeEventListener('loadCellValueObject');
    },
    computed: {
        isLadingPageSelected() {
            return (!this.selectedUnlayerLandingPage) || this.selectedUnlayerLandingPage.length === 0;
        },

        isSaveDisabled() {
            return (!this.selectedUnlayerLandingPage) || this.selectedUnlayerForm.length === 0;
        },
        landingPageLink() {
            let createLandingPageUrl;

            if (this.spaApp || this.newNavigation) {
                createLandingPageUrl = `${this.spaBaseUrl}/marketing-sites/create/?app_id=${this.appId}`;
            } else {
                createLandingPageUrl = `${this.createUrl}`;
            }

            return createLandingPageUrl;
        },
    },

    methods: {
        async loadCellValueObject(event) {
            this.$nextTick(async () => {
                await this.loadUnlayerLandingPageOptions();

                if (event && event.detail && event.detail.cellValue) {
                    const {
                        unlayerLandingPageId,
                        unlayerLandingPageTitle,
                        unlayerFormIds,
                    } = event.detail.cellValue;

                    if (unlayerLandingPageId) {
                        this.selectedUnlayerLandingPage = {};
                        this.selectedUnlayerLandingPage.id = unlayerLandingPageId;
                        this.selectedUnlayerLandingPage.title = unlayerLandingPageTitle;

                        await this.loadUnlayerForm();

                        if (unlayerFormIds) {
                            this.selectedUnlayerForm = unlayerFormIds;
                        }
                    }

                    this.jgraph = event.detail.jgraph;
                    this.cellInfo = event.detail.cellInfo;
                    this.cellValue = event.detail.cellValue;
                    this.saveCellOptions = event.detail.options;
                    this.saveCellOptions.saver = undefined;
                }

                this.unlayerPageKeyId = 'unlayerPageKeyMS';
                this.unlayerFormKeyId = 'unlayerFormKeyMS';
            });
        },

        closeModal() {
            document.querySelector('span.container-close').click();
        },

        saveCell() {
            const { id, title } = this.selectedUnlayerLandingPage;
            const unlayerFormIds = this.selectedUnlayerForm;
            const unlayerFormValues = [];

            for (let index = 0; index < unlayerFormIds.length; index++) {
                const formIdValue = unlayerFormIds[index].toString();

                unlayerFormValues.push(formIdValue);
            }

            this.cellValue.unlayerLandingPageId = id;
            this.cellValue.unlayerLandingPageTitle = title;
            this.cellValue.unlayerFormIds = unlayerFormValues;

            const eventData = {
                detail: {
                    cellValue: this.cellValue,
                    cellInfo: this.cellInfo,
                    jgraph: this.jgraph,
                    options: this.saveCellOptions,
                },
            };

            this.$emit('save-cell', eventData);

            this.closeModal();
        },

        editLandingPage() {
            if (this.spaApp || this.newNavigation) {
                window.open(`${this.spaBaseUrl}/marketing-sites/edit/${this.selectedUnlayerLandingPage.id}/?app_id=${this.appId}`, '_blank', 'noopener,noreferrer');
            } else {
                window.open(`${this.editUrl}/${this.selectedUnlayerLandingPage.id}`, '_blank', 'noopener,noreferrer');
            }
        },
        async loadUnlayerLandingPageOptions() {
            try {
                this.loadingLandingPage = true;
                const results = await dataService.loadUnlayerLandingPageOptions();

                this.unlayerLandingPageOptions = JSON.parse(results);
            } finally {
                this.loadingLandingPage = false;
            }
        },
        async loadUnlayerForm() {
            try {
                this.loadingForms = true;

                const { id } = this.selectedUnlayerLandingPage;
                const results = await dataService.getFormOptions(id);


                this.unlayerFormOptions = JSON.parse(results);
            } finally {
                this.loadingForms = false;
            }
        },
        async searchLandingPage(inputValue) {
            if (inputValue) {
                const results = await dataService.searchTemplateGroups(inputValue);

                if (results) {
                    this.unlayerLandingPageOptions = JSON.parse(results);
                }
            } else {
                await this.loadUnlayerLandingPageOptions();
            }
        },
    },
};
</script>
<style lang="scss">
.unlayer-landing-page-body .ds-card {
    width: 100%;
    background-color: #f0f0f0;
}
div#unlayer-landing-page > div.dropdown-menu.open > div.menu {
    height: min-content;
}
div#unlayer-landing-page > svg.icon {
    width: 48px;
    padding-left: 0px;
}

div#unlayer-landing-page > div#lightbox {
    display: grid;
    grid-template-areas: 'containerclose headertext savebutton' 'lightboxcontent lightboxcontent lightboxcontent';
    grid-template-columns: 6% 80% 14%;
    background-color: #fff;
    width: 640px;
    border-radius: 12px;
}
div#unlayer-landing-page > div#lightbox-content {
    grid-area: lightboxcontent;
    border-top: 1px solid #DDDDDD;
}
div#lightbox > div.hd {
    grid-area: headertext;
    background-color: #fff;
    border-bottom: none;
    height: 56px;
    font-weight: bold;
}
form > .closemodal {
    grid-area: containerclose;
    background-color: #fff;
    padding: 0;
    margin: 0;
    left: 20px;
    width: auto;
    height: auto;
    position: absolute;
    top: 12px;
    left: 12px;
}
div#unlayer-landing-page > svg.icon {
    width: 48px;
    padding-left: 0px;
}
div#unlayer-landing-page > span.container-close {
    visibility: hidden;
}
div#unlayer-landing-page > div.multiselect-tags > span.input-span > label {
    top: 2px;
}
div#unlayer-landing-page > div.multiselect-tags > span.input-span > label.pill-label {
    top: 0px;
}
div#unlayer-landing-page > div.active div.multiselect-tags > span.input-span > label,
div#unlayer-landing-page > div.multiselect-tags > span.input-span > label.static-label {
    top: -1px;
}
div#unlayer-landing-page > span.summary-label {
    color: rgba(0, 0, 0, 0.4);
}
p.summary-text {
    margin-top: 15px;
    margin-bottom: 20px;
}
div#unlayer-landing-page > .dropdown-menu.open {
    border: none;
    padding: 0px;
}

#unlayerLandingPage-selection > div > div.dropdown-reference > div > div.multiselect-tags > span {
    margin-top: 5px;
}
</style>

<style lang="scss" scoped>
.unlayer-landing-page {
    width:      100%;
    height:     fit-content;
    margin:     0;
    padding:    0;
}

.unlayer-landing-page-body {
    width:  100%;
    padding:    0px 24px 16px 24px;
}

form > .close-modal {
    grid-area: containerclose;
    position: absolute;
    top: 8px;
    left: 8px;
}

form > .save-button {
    grid-area: savebutton;
    position: absolute;
    top: 12px;
    right: 16px;
    height: 32px;
    width: 55px;
    padding: 0;
}

.create-landing-page-link {
    flex-direction: row;
    gap: $spacing-050;
    --icon-size: #{px-to-rem(13.33px)};
    color: $color-blue;
}

.table-lp {
    border: 0rem;
    cellpadding: 0rem;
    cellspacing: 0rem;
}

.table-lp .left-column {
    padding: 0.1rem ;
    width: 75%;
}

.table-lp .right-column {
    padding: 0.1rem ;
    text-align: right;
    width: 25%;
}

.table-lp .single-column {
    padding: 0.1rem ;
}

form > .button > .edition {
    position: absolute;
    top: 12px;
    right: 16px;
    height: 32px;
    width: 55px;
    padding: 0;
    button-text-color: #0042DB;
    button-background-color: #ffffff;
}

</style>
